import { siteConfig } from "~/config/site"

const RELATIVE_FEED_PATH = "/rss.xml"

// Fail closed to a relative path when NEXT_PUBLIC_SITE_URL is missing/invalid
// (e.g. under SKIP_ENV_VALIDATION) so importing this module never throws at init.
function resolveFeedUrl(): string {
  try {
    return new URL(RELATIVE_FEED_PATH, siteConfig.url).toString()
  } catch {
    return RELATIVE_FEED_PATH
  }
}

export const linksConfig = {
  feeds: [{ title: "Tools", url: "/rss.xml" }],
  socials: { x: "https://x.com/webscraping_app" },
  feed: resolveFeedUrl(),
  x: "https://x.com/webscraping_app",
  linkedin: "https://www.linkedin.com/company/126243989",
}
